/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../api/index';
import * as core from '../../../../core';
import * as serializers from '../../../index';

export const DraftLatestIssueRequestDidMethod: core.serialization.Schema<
    serializers.DraftLatestIssueRequestDidMethod.Raw,
    Truvity.DraftLatestIssueRequestDidMethod
> = core.serialization.enum_(['key', 'web']);

export declare namespace DraftLatestIssueRequestDidMethod {
    export type Raw = 'key' | 'web';
}
